/**
 * @description: Request result set
 */
export enum ResultEnum {
  SUCCESS = 0,
  ERROR = 1,
  // 交付物提交时，现有状态与之前进入页面状态不同时的状态码
  MULTI_EDIT_CONTRADICT = -1,
  // 交付物提交时，自动驳回的状态码
  AUTO_RULE_FAIL = 513,
  TIMEOUT = 401,
  TYPE = 'success',
  ERRORDOMAIN = 4022,
  ERROR_QUALIFICATIONS = 511, // 资质校验失败code
}

/**
 * @description: request method
 */
export enum RequestEnum {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

/**
 * @description:  contentTyp
 */
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  FORM_DATA = 'multipart/form-data;charset=UTF-8',
}

/**
 * 请求header
 * @description:  contentTyp
 */
export enum ConfigEnum {
  // TOKEN
  TOKEN = 'X-Access-Token',
  // TIMESTAMP
  TIMESTAMP = 'X-TIMESTAMP',
  // Sign
  Sign = 'X-Sign',
  // 租户id
  TENANT_ID = 'tenant-id',
  // 版本
  VERSION = 'X-Version',
  USERTYPE = 'User-type'
}
